(function(EF) {

  var ContentPage = Backbone.Model.extend({
    initialize: function(attrs, options) {
      var self = this;
      this.pageData = {};
      if(this.get('key')) this.key = this.get('key');
      // Bind all the methods to the current scope
      _.bindAll(this,
        'complete',
        'unload',
        'play',
        'init',
        'pause',
        'stop',
        'reload',
        'unpause',
        'mute',
        'setProgress'
      );

      this.on('play', function() {
        this._startedPlaying = true;
      });
      this.on('pause', function() {
        this._isPaused = true;
      });
      this.on('unpause', function() {
        this._isPaused = false;
      });
      this.on('reload', function() {
        this._startedPlaying = false;
        this._isPaused = false;
      });
      this.on('change:completed', function() {
        if(self.get('completed')) {
          self.completed = true;
        } else {
          self.completed = false;
        }
      });
    },
    unload: function() {
      this.trigger('unload');
    },
    play: function() {},
    init: function() {},
    pause: function() {},
    stop: function() {},
    reload: function() {},
    unpause: function() {},
    mute: function() {},
    complete: function() {
      this.trigger('complete');
    },

    setProgress: function(progressObj) {
      if(!progressObj) {
        this.progress = {
          key: this.key,
          completed: false
        };
        this.set('completed', false);
      } else {
        this.progress = progressObj;
        if(progressObj.data) {
          this.pageData = progressObj.data;
          this.set('pageData', this.pageData);
        }
        this.set('completed', progressObj.completed);
      }
      EF.trigger('page:progress:set', this);
    },

    // ### skipTo
    // skips to a page in the current activity with the passed in key and
    // marks all the pages in between the current and the new page completed.

    skipTo: function(pageKey) {
      var endPage = EF.module.currentActivity.pages.getPageByKey(pageKey);
      var page = EF.module.currentActivity.pages.getPageByKey(EF.currentPage.key);
      while(page && page.get('key') !== endPage.get('key')) {
        markPageComplete(page);
        page = EF.module.getNextPage();
      }
      EF.loadPage(pageKey);
    },

    completeThruCurrentPage: function(includeCurrent) {
      var self = this;
      EF.module.currentActivity.pages.each(function(page) {
        if(page.get('index') < self.page.get('index') ||
          (page.get('index') == self.page.get('index') && includeCurrent)) {
          markPageComplete(page);
        }
      });
    },

    completeActivity: function() {
      if(EF.module.currentActivity.isComplete()) {
        EF.module.currentActivity.set('completed', true);
        return;
      }
      var page = EF.module.currentActivity.currentPage;
      while(page) {
        markPageComplete(page);
        page = EF.module.getNextPage();
      }
    }
  });

  function markPageComplete(page) {
    EF.pageLoader(page.get('key'), function(cp) {
      //Mark the page as completed.
      cp.moduleId = EF.module.get('id');
      cp.moduleKey = EF.module.get('key');
      cp.activityKey = EF.module.currentActivity.get('key');
      cp.setProgress(EF.module.progress.forPageAndActivity(page.get('key'), cp.activityKey));
      cp.set('completed', true);
      cp.completed = true;
      EF.module.saveProgress(cp);
    });
  }

  _.extend(EF.Models, {
    ContentPage: ContentPage
  });

})(window.EF);